var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-517d00c2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/baseComponents/FlexContainer/FlexContainer.vue
// module id = 811
// module chunks = 0